<template>
  <div class="form-control p-0 border-0 bg-transparent">
    <VueDatePicker
      v-model="localValue"
      locale="de"
      text-input
      :auto-apply="options.autoApply"
      :enable-time-picker="options.enableTimePicker"
      :format-locale="de"
      :format="format"
      :time-picker="options.timePicker"
      :min-date="minDate"
      :max-date="maxDate"
      :position="position"
      :prevent-min-max-navigation="preventMinMaxNavigation"
      :cancel-text="trans('common.datetimepicker.cancel')"
      :placeholder="trans('common.datetimepicker.placeholder')"
      :select-text="trans('common.datetimepicker.select')"
      @update:model-value="(date) => updateData(date)"
    ></VueDatePicker>
  </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import moment from 'moment';
import { de } from 'date-fns/locale';
import { ref, watch } from 'vue';

export default {
  components: {
    VueDatePicker,
  },
  props: {
    attribute: { type: String, default: null },
    errors: { type: Array, default: null },
    name: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    type: { type: String, default: 'text' },
    value: { type: [String, Number], default: '' },
    format: { type: String, default: 'dd.MM.yyyy HH:mm' },
    minDate: { type: Number, default: null },
    maxDate: { type: Number, default: null },
    position: { type: String, default: 'left' },
    preventMinMaxNavigation: { type: Boolean, default: false },
    options: {
      type: Object,
      default: () => ({
        autoApply: false,
        enableTimePicker: true,
        timePicker: false,
      }),
    },
  },
  emits: ['update:data'],
  setup(props, { emit }) {
    const localValue = ref(props.value);

    const updateData = (date) => {
      emit('update:data', date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : null);
    };

    watch(
      () => props.value,
      (updatedValue) => {
        localValue.value = updatedValue;
      }
    );

    return {
      localValue,
      updateData,
      de,
    };
  },
};
</script>

<style>
.form-control .dp__main .dp__input {
  padding-top: 1rem;
}
</style>
